import { useSound } from 'use-sound';
import firstWarning from '@/assets/sounds/player_turn_first_warning_alt.wav';
import secondWarning from '@/assets/sounds/player_turn_second.mp3';
import deal from '@/assets/sounds/card_dealing_to_player.wav';
import boardDeal from '@/assets/sounds/flop.wav';
import turnRiverDeal from '@/assets/sounds/turn_river.wav';
import chipsGoingToPot from '@/assets/sounds/chips_going_to_pot.wav';
import chipsPullingToPot from '@/assets/sounds/poker_chips_flying_up.mp3';
import chipsMany from '@/assets/sounds/chips_many.wav';
import bet from '@/assets/sounds/bet_poker_chips.mp3';
import folding from '@/assets/sounds/folding.wav';
import winGame from '@/assets/sounds/poker_win_rock_sound-heavy.mp3';
import loseGame from '@/assets/sounds/poker_lose_rock_cheerful.mp3';
import call from '@/assets/sounds/player_calls.wav';
import check from '@/assets/sounds/player_check.wav';
import chipsFalling from '@/assets/sounds/poker_chips_flying_down.mp3';

const useTableSounds = () => {
  const [playFirstWarning] = useSound(firstWarning, { volume: 0.6 });
  const [playSecondWarning] = useSound(secondWarning, { volume: 0.6 });
  const [playDeal] = useSound(deal);
  const [playBoardDeal] = useSound(boardDeal);
  const [playChipsGoingToPot] = useSound(chipsGoingToPot, { volume: 0.6 });
  const [playChipsPullingToPot] = useSound(chipsPullingToPot, { volume: 0.6 });
  const [playChipsMany] = useSound(chipsMany, { volume: 0.5 });
  const [playChipsFalling] = useSound(chipsFalling, { volume: 0.6 });
  const [playBet] = useSound(bet, { volume: 0.45 });
  const [playFolding] = useSound(folding);
  const [playWin] = useSound(winGame);
  const [playLose] = useSound(loseGame);
  const [playCall] = useSound(call, { volume: 0.6 });
  // const [playCheck] = useSound(check);
  const [playCheck] = useSound(check, { volume: 0.4 });
  const [playTurnRiverDeal] = useSound(turnRiverDeal);

  return {
    playFirstWarning,
    playSecondWarning,
    playDeal,
    playBoardDeal,
    playChipsGoingToPot,
    playChipsPullingToPot,
    playChipsMany,
    playChipsFalling,
    playBet,
    playFolding,
    playCall,
    playWin,
    playLose,
    playCheck,
    playTurnRiverDeal,
  };
};

export default useTableSounds;
